export default {
  Codigo: null,
  CodigoOrdenProduccion: null,
  ItemProducto: null,
  CodigoEspecificacionTecnica: null,
  Descripcion: null,
  Cantidad: null,
  Repeticion: null,
  CantidadBocas: null,
};
